import React, { createRef } from "react";
import Tilt from "react-tilted";
import { Title, Wrapper } from "../../GlobalStyle";
import { AboutWrapper } from "./Styled";

import AboutImg from "../../images/AboutImg";
import { useOnScreen } from "../../components/useOnScreen";

function About() {
  const containerRef = createRef();
  const isVisible = useOnScreen(containerRef);

  return (
    <AboutWrapper
      id="about"
      className={isVisible ? "active" : ""}
      ref={containerRef}
    >
      <Wrapper>
        <div className="about-left">
          <Tilt className="Tilt" max={25} speed={2000}>
            <div className="Tilt-inner">
              <AboutImg />
            </div>
          </Tilt>
          {/*<img src={require("../../images/about-img.png")} alt="Seedverse" />*/}
        </div>
        <div className="about-right">
          <Title>About SEEDverse</Title>
          <p>
            A turn-key provider of NFT and digital solutions to creators and
            companies looking to monetize, fund-raise, and retain customer
            loyalty
          </p>
        </div>
      </Wrapper>
    </AboutWrapper>
  );
}
export default About;
